import { Session, SessionData } from '@ally/federated-types'
import { StatusTrackerActivity } from '@ally/shared-status-tracker'

type FetchParams = {
  guid: string
  session: Session
}

export const fetchActivitiesData = async ({
  guid,
  session,
}: FetchParams): Promise<StatusTrackerActivity[]> => {
  const { data } = session
  const { AwsAccessToken, CSRFChallengeToken } = data as SessionData
  const endpointUrl = `/acs/customers/${guid}/activities`

  const awsToken =
    AwsAccessToken ||
    (sessionStorage &&
      JSON.parse(sessionStorage.getItem('AwsAccessToken') || ''))

  return fetch(endpointUrl, {
    method: 'GET',
    headers: {
      ...(CSRFChallengeToken ? { CSRFChallengeToken } : {}),
      Authorization: `Bearer ${awsToken}`,
      'patron-id': 'olbWeb',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json, text/javascript, */*; q=0.01',
    } as HeadersInit,
  })
    .then(response => response.json().then(activities => activities))
    .catch(error => console.log('FETCH ACTIVITIES ERROR:', error))
}
